import client from 'data/client';
import { BIFData } from 'data/types/BIF';

const getBIF = async (org_id: string) => {
  const ZEUS_API_URL = import.meta.env.VITE_APP_ZEUS_API_URL;
  const response = await client.get<BIFData>(
    `${ZEUS_API_URL}bif/entry/org/${org_id}`,
  );
  response.data.owner_phone = response.data.owner_phone
    .slice(-10)
    .replace(/\D/g, '');
  return response.data;
};

export default getBIF;
